/* OnePod P3 (04-10-2026): kleine helpers voor de nieuwe productpagina (sections/main-product met
   op_ontwerp). Alles wat de server kan, staat al in de HTML; dit script werkt alleen bij een keuze bij.
   - Knop zonder keuze (P1, open compatibiliteitskeuze): een klik geeft een melding, een petrolrand
     om de keuze en focus op de eerste optie. De knop zelf blijft uit (variant-picker.js), zodat er
     nooit stil een uitvoering in de wagen gaat.
   - "Waar staat het nummer?" / "Hoe zie ik dat?": opent de eerste uitklap en scrollt erheen.
   - Modelnummers in de keuzevakken (oortjes op regel 1, "case ..." op regel 2) en de tabel in de
     uitklap, uit window.OP_AIRPODS_FAMILIES (op-airpods-generatie.js, de ene bron, P1).
   - Tegels "Je set" en de link naar het andere oortje volgen de gekozen uitvoering of kleur, uit
     het JSON-blok dat Liquid rendert (geen extra fetch).
   Raakt niet: rw-prefer-stock, blokkeerUitverkocht, kleurthumbnails (op-polish.js / variant-picker). */
(function () {
  'use strict';
  if (window.__opPdp) return;
  window.__opPdp = true;

  function root() { return document.querySelector('.op-pdp'); }
  function picker() { var r = root(); return r && r.querySelector('variant-picker'); }

  /* gekozen waarde van de eerste optie, of null bij een open keuze */
  function gekozen() {
    var vp = picker();
    if (!vp || vp.hasAttribute('data-op-leeg')) return null;
    var inp = vp.querySelector('input.js-option:checked');
    return inp ? inp.value : null;
  }

  /* ---------- knop zonder keuze ---------- */
  function toonKeuze() {
    var vp = picker();
    if (!vp) return;
    var fs = vp.querySelector('fieldset[data-op-uitvoering]') || vp.querySelector('fieldset');
    var m = root().querySelector('[data-op-melding-uit]');
    if (m) m.textContent = vp.getAttribute('data-op-melding') || 'Kies eerst je uitvoering.';
    if (fs) {
      fs.classList.add('op-kies-aan');
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var eerste = fs.querySelector('input.js-option:not([disabled])');
      if (eerste) eerste.focus({ preventScroll: true });
    }
  }
  document.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('.op-pdp .product-info__add-button.op-kies');
    if (!w) return;
    var vp = picker();
    var knop = w.querySelector('.js-add-to-cart');
    if (!vp || !vp.hasAttribute('data-op-leeg') || (knop && !knop.disabled)) return;
    e.preventDefault();
    toonKeuze();
  });

  /* ---------- "Waar staat het nummer?" ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-op-naar-welke]');
    if (!a) return;
    var r = root();
    var d = r && r.querySelector('.product-info details.disclosure');
    if (!d) return;
    e.preventDefault();
    var sum = d.querySelector('summary');
    if (!d.open && sum) sum.click();
    setTimeout(function () {
      d.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (sum) sum.focus({ preventScroll: true });
    }, 60);
  });

  /* ---------- modelnummers ---------- */
  function familie(waarde) {
    var fam = window.OP_AIRPODS_FAMILIES;
    if (!fam) return null;
    for (var k in fam) { if (fam[k].vt && fam[k].vt === waarde) return fam[k]; }
    return null;
  }
  function zetNummers() {
    var r = root();
    if (!r || !window.OP_AIRPODS_FAMILIES) return;
    r.querySelectorAll('fieldset[data-op-uitvoering] input.js-option').forEach(function (inp) {
      var lab = r.querySelector('label[for="' + inp.id + '"]');
      var f = familie(inp.value);
      if (!lab || !f || lab.querySelector('.op-mnr[data-op-p3]')) return;
      var sm = lab.querySelector('.op-mnr');
      if (!sm) { sm = document.createElement('small'); sm.className = 'op-mnr'; (lab.querySelector('span') || lab).appendChild(sm); }
      sm.setAttribute('data-op-p3', '');
      sm.textContent = (f.earbuds || []).join(', ');
      if (f.cases && f.cases.length) {
        sm.appendChild(document.createElement('br'));
        sm.appendChild(document.createTextNode('case ' + f.cases.join(', ')));
      }
    });
    r.querySelectorAll('[data-op-mnr-tabel]').forEach(function (box) {
      if (box.firstChild) return;
      var waarden = (box.getAttribute('data-waarden') || '').split('||');
      var fams = waarden.map(familie);
      if (fams.some(function (f) { return !f; })) return;
      var t = document.createElement('table');
      t.className = 'op-spec';
      var kop = '<thead><tr><th scope="col"><span class="visually-hidden">Kenmerk</span></th>';
      waarden.forEach(function (w) { kop += '<th scope="col">' + esc(w) + '</th>'; });
      kop += '</tr></thead><tbody><tr><th scope="row">Nummer oortjes</th>';
      fams.forEach(function (f) { kop += '<td>' + esc((f.earbuds || []).join(', ')) + '</td>'; });
      kop += '</tr><tr><th scope="row">Nummer case</th>';
      fams.forEach(function (f) { kop += '<td>' + esc((f.cases || []).join(', ')) + '</td>'; });
      t.innerHTML = kop + '</tr></tbody>';
      box.appendChild(t);
    });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- tegels "Je set" en de link naar het andere oortje ---------- */
  var setData = null;
  function leesSet() {
    if (setData !== null) return setData;
    var sc = document.querySelector('[data-op-set-data]');
    try { setData = sc ? JSON.parse(sc.textContent) : false; } catch (e) { setData = false; }
    return setData;
  }
  var ST = { ok: 'Op voorraad', na: 'Nalevering', uit: 'Uitverkocht' };
  function breedte(url, w) { return url.replace(/([?&]width=)\d+/, '$1' + w); }
  function bewaar(el, sleutel, waarde) { if (!(sleutel in el.dataset)) el.dataset[sleutel] = waarde; }

  function zetTegels(sel) {
    var data = leesSet();
    if (!data) return;
    document.querySelectorAll('[data-op-tegel]').forEach(function (li) {
      var d = data[+li.getAttribute('data-op-tegel')];
      if (!d) return;
      var x = sel && d.v ? d.v[sel] : null;
      var a = li.querySelector('a.op-tegel__in');
      var pr = li.querySelector('[data-op-t-prijs]');
      var st = li.querySelector('[data-op-t-st]');
      var img = li.querySelector('img');
      if (pr) bewaar(li, 'opP0', pr.textContent);
      if (a) bewaar(li, 'opH0', a.getAttribute('href'));
      if (st) { bewaar(li, 'opS0', st.textContent); bewaar(li, 'opC0', st.className); }
      if (img) { bewaar(li, 'opI0', img.getAttribute('src') || ''); bewaar(li, 'opJ0', img.getAttribute('srcset') || ''); }
      if (x) {
        if (pr) pr.textContent = x.p;
        if (d.d) return;
        if (a) a.setAttribute('href', d.u + '?variant=' + x.i);
        if (st) { st.textContent = ST[x.s] || ''; st.className = 'op-tegel__st' + (x.s === 'ok' ? ' op-tegel__st--ok' : ''); }
        if (img && x.f) { img.setAttribute('src', x.f); img.setAttribute('srcset', breedte(x.f, 240) + ' 240w, ' + x.f + ' 400w, ' + breedte(x.f, 600) + ' 600w'); }
      } else {
        if (pr) pr.textContent = li.dataset.opP0;
        if (d.d) return;
        if (a) a.setAttribute('href', li.dataset.opH0);
        if (st) { st.textContent = li.dataset.opS0; st.className = li.dataset.opC0; }
        if (img && li.dataset.opI0) { img.setAttribute('src', li.dataset.opI0); img.setAttribute('srcset', li.dataset.opJ0); }
      }
    });
    var intro = document.querySelector('[data-op-set-intro]');
    if (intro) {
      intro.textContent = sel
        ? (intro.getAttribute('data-tekst-gekozen') || '').replace('[waarde]', sel)
        : (intro.getAttribute('data-tekst-leeg') || intro.textContent);
    }
  }

  function zetAndere(sel) {
    var a = document.querySelector('[data-op-andere]');
    if (!a) return;
    var pr = a.querySelector('[data-op-andere-prijs]');
    bewaar(a, 'opH0', a.getAttribute('href'));
    if (pr) bewaar(a, 'opP0', pr.textContent);
    var map = {};
    try { map = JSON.parse(a.getAttribute('data-op-varianten') || '{}'); } catch (e) { map = {}; }
    var x = sel ? map[sel] : null;
    if (x) {
      a.setAttribute('href', a.getAttribute('data-url') + '?variant=' + x.i);
      if (pr) pr.textContent = x.p;
    } else {
      a.setAttribute('href', a.dataset.opH0);
      if (pr) pr.textContent = a.dataset.opP0;
    }
  }

  function naKeuze() {
    var r = root();
    if (!r) return;
    var sel = gekozen();
    if (sel) {
      var w = r.querySelector('.product-info__add-button.op-kies');
      if (w) w.classList.remove('op-kies');
      var m = r.querySelector('[data-op-melding-uit]');
      if (m) m.textContent = '';
      r.querySelectorAll('fieldset.op-kies-aan').forEach(function (f) { f.classList.remove('op-kies-aan'); });
    }
    zetTegels(sel);
    zetAndere(sel);
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('js-option') && e.target.closest('.op-pdp')) {
      setTimeout(naKeuze, 40);
    }
  });

  function start() { zetNummers(); naKeuze(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* op-airpods-generatie.js staat lager in de pagina (defer) en is er pas bij DOMContentLoaded;
     deze luisteraar komt na die van op-polish.js zetModelnummers(), dus hier wordt de regel herschreven */
  document.addEventListener('DOMContentLoaded', zetNummers);
  window.addEventListener('load', zetNummers);
})();
